import React from 'react';
import { string, arrayOf, shape, number } from 'prop-types';
import css from './SectionTestimonials.module.css';

const StarRating = ({ count }) => (
  <span role="img" aria-label={`${count} out of 5 stars`} className={css.stars}>
    {Array.from({ length: count }).map((_, i) => (
      <svg key={i} aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="#ffc107" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ))}
  </span>
);

const TrainerInitials = ({ name }) => {
  const initials = name
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('');
  return <div className={css.trainerAvatar}>{initials}</div>;
};

const SectionTestimonials = props => {
  const { title, subtitle, testimonials } = props;

  return (
    <section className={css.root}>
      <div className={css.container}>
        <h2 className={css.title}>{title}</h2>
        {subtitle && <p className={css.subtitle}>{subtitle}</p>}

        <div className={css.grid}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className={css.card}>
              {/* Trainer — the product — leads the card */}
              <div className={css.trainer}>
                <TrainerInitials name={testimonial.trainerName} />
                <div className={css.trainerInfo}>
                  <h4 className={css.trainerName}>{testimonial.trainerName}</h4>
                  <p className={css.trainerCity}>{testimonial.trainerCity}</p>
                </div>
              </div>

              <StarRating count={testimonial.stars} />

              <p className={css.text}>"{testimonial.text}"</p>

              {/* Client credit at the bottom */}
              <p className={css.authorCredit}>— {testimonial.authorName}</p>

              {testimonial.trainerLink && (
                <a href={testimonial.trainerLink} className={css.trainerLink}>
                  {testimonial.trainerLinkText}
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

SectionTestimonials.defaultProps = {
  subtitle: null,
  testimonials: [],
};

SectionTestimonials.propTypes = {
  title: string.isRequired,
  subtitle: string,
  testimonials: arrayOf(
    shape({
      stars: number.isRequired,
      trainerName: string.isRequired,
      trainerCity: string.isRequired,
      text: string.isRequired,
      authorName: string.isRequired,
      trainerLink: string,
      trainerLinkText: string,
    })
  ),
};

export default SectionTestimonials;
